import { displayNotif } from 'hb-react/shared/helpers/notifications';
import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

import { dynamicDonationResourcePath } from '../utils/whiteLabel';

const fetchOrder = (campaignId, whitelabelURLEnabled, options, callback) => {
  const { search } = window.location;
  const params = new URLSearchParams(search);
  const fundId = params.get('fund_id');

  let args = { format: 'json' };

  if (fundId) {
    args = {
      format: 'json',
      fund_id: fundId,
    };
  }

  const route = options?.isPreview
    ? Routes.preview_donation_path(campaignId, args)
    : Routes.donation_path(campaignId, args);

  const dynamicRoute = dynamicDonationResourcePath(route, {
    whitelabelURL: whitelabelURLEnabled,
  });

  axios
    .get(dynamicRoute)
    .then(({ data }) => callback(data))
    .catch(() => displayNotif('error', s__('Donations|Unauthorized')));
};

export default fetchOrder;
